import { actionTypes as types } from '../constants'

const initialState = {
  isSessionExpired: false,
  isRequestBlocked: false,
  isNotFound: false,
  loginUrl: '/',
  showLoadingSpinner: false,
}

function common(state = initialState, action = {}) {
  switch (action.type) {
    case types.SESSION_EXPIRED:
      return {
        ...state,
        isSessionExpired: true,
        loginUrl: action.loginUrl || '/',
      }

    case types.REQUEST_BLOCKED:
      return {
        ...state,
        isRequestBlocked: {
          actionType: action.blockedActionType,
        },
      }

    case types.NOT_FOUND:
      return {
        ...state,
        isNotFound: true,
      }

    case types.RESET_NOT_FOUND:
      return {
        ...state,
        isNotFound: false,
      }

    case types.SHOW_LOADING_SPINNER:
      return {
        ...state,
        showLoadingSpinner: true,
      }

    default:
      return state
  }
}

export default common
